export const ROUTING_FEE_PERCENT = 0.1;

export const ROUTING_FEE_RATIO = (100 - ROUTING_FEE_PERCENT) / 100;
